var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('custom-toolbar'),_c('v-row',{staticClass:"pt-5 full-height",attrs:{"justify":"center","align":"center","fill-height":""}},[_c('article-details',{attrs:{"customWidth":'100vw',"filtersNamespace":"articleFilters","externalUserToken":_vm.token}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }